import { useState, createContext, useCallback } from 'react';
import { getByUser } from '../api/bankAccountApi';

export const BankAccountContext = createContext();

export const BankAccountProvider = ({ children }) => {
    const [bankAccounts, setBankAccounts] = useState([]);

    const getUserBankAccount = useCallback(async () => {
        const response = await getByUser();
        if(response.isSuccess){
            setBankAccounts(response.data);
        }
    }, []);

    return (
        <BankAccountContext.Provider value={{
            bankAccounts,
            setBankAccounts,
            getUserBankAccount
        }}
        >
            {children}
        </BankAccountContext.Provider>
    );
};